var _rect, _g, _circle, _circle2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapeRange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 624,
    height: 68,
    viewBox: "0 0 624 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 32,
    width: 624,
    height: 5,
    rx: 2.5,
    fill: "url(#paint0_linear_932_1040)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_932_1040)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 342,
    cy: 34,
    r: 14,
    fill: "#7130C3"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 342,
    cy: 34,
    r: 10,
    fill: "#7130C3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 342,
    cy: 34,
    r: 5,
    fill: "#070710"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_932_1040",
    x: 308,
    y: 0,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_932_1040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_932_1040",
    x1: -4.02613,
    y1: 33.8066,
    x2: 109.394,
    y2: 283.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1066,
    stopColor: "#DD00AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5303,
    stopColor: "#7130C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9634,
    stopColor: "#410093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF00EE",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3BD4",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeRange);
export default __webpack_public_path__ + "static/media/shape_range.0a7e3a0d56ce5db236c62fa0dae5452b.svg";
export { ForwardRef as ReactComponent };